import { IActionOptions } from '@interfaces/IActionOptions';
import { IEvent } from '@interfaces/IEvent';
import { Action } from '@ngrx/store';

export enum EEventsActions {
  AddEvent = '[Events] Add Event',
  AddEventSuccess = '[Events] Add Event Success',
  AddEventFailure = '[Events] Add Event Failure',

  DeletePeriodEvents = '[Events]  Delete Period Events',

  DeleteEventFile = '[Events] Delete Event File',
  DeleteEventFileSuccess = '[Events] Delete Event File Success',
  DeleteEventFileFailure = '[Events] Delete Event File Failure',

  AddEventMaterial = '[Events] Add Event Material',
  AddEventMaterialSuccess = '[Events] Add Event Material Success',
  AddEventMaterialFailure = '[Events] Add Event Material Failure',

  AddEventVisits = '[Events] Add Event Visits',
  AddEventVisitsSuccess = '[Events] Add Event Visits Success',
  AddEventVisitsFailure = '[Events] Add Event Visits Failure',

  GetEventVisits = '[Events]  Get Event Visits',
  GetEventVisitsSuccess = '[Events]  Get Event Visits Success',
  GetEventVisitsFailure = '[Events]  Get Event Visits Failure',

  ClearEventVisits = '[Events] Clear Event Visits',
}

export class AddEventMaterial implements Action {
  public readonly type = EEventsActions.AddEventMaterial;

  constructor(public eventMaterial: { eventId: number; type: string }) {}
}

export class AddEventMaterialSuccess implements Action {
  public readonly type = EEventsActions.AddEventMaterialSuccess;

  constructor(public id: number) {}
}

export class AddEventMaterialFailure implements Action {
  public readonly type = EEventsActions.AddEventMaterialFailure;
}

export class AddEventSuccess implements Action {
  public readonly type = EEventsActions.AddEventSuccess;
}
export class DeleteEventFileFailure implements Action {
  public readonly type = EEventsActions.DeleteEventFileFailure;
}

export class AddEventFailure implements Action {
  public readonly type = EEventsActions.AddEventFailure;

  constructor(public errors: { [key: string]: string[] }) {}
}

export class DeleteEventFile implements Action {
  public readonly type = EEventsActions.DeleteEventFile;

  constructor(public event_id: number, public eventId: number) {}
}

export class DeleteEventFileSuccess implements Action {
  public readonly type = EEventsActions.DeleteEventFileSuccess;

  constructor(public file_id: number) {}
}

export class AddEvent implements Action {
  public readonly type = EEventsActions.AddEvent;

  constructor(public event: IEvent, public period?: number) {}
}

export class DeletePeriodEvents implements Action {
  public readonly type = EEventsActions.DeletePeriodEvents;

  constructor(public period_id: number) {}
}

export class AddEventVisits implements Action {
  public readonly type = EEventsActions.AddEventVisits;

  constructor(
    public id: number,
    public students: number[],
    public options?: IActionOptions
  ) {}
}

export class AddEventVisitsSuccess implements Action {
  public readonly type = EEventsActions.AddEventVisitsSuccess;
}

export class AddEventVisitsFailure implements Action {
  public readonly type = EEventsActions.AddEventVisitsFailure;
}

export class GetEventVisits implements Action {
  public readonly type = EEventsActions.GetEventVisits;

  constructor(public id: number) {}
}

export class GetEventVisitsSuccess implements Action {
  public readonly type = EEventsActions.GetEventVisitsSuccess;

  constructor(public ids: number[]) {}
}

export class GetEventVisitsFailure implements Action {
  public readonly type = EEventsActions.GetEventVisitsFailure;
}

export class ClearEventVisits implements Action {
  public readonly type = EEventsActions.ClearEventVisits;
}

export type EventsActions =
  | AddEvent
  | DeletePeriodEvents
  | DeleteEventFile
  | DeleteEventFileSuccess
  | AddEventFailure
  | AddEventSuccess
  | DeleteEventFileFailure
  | AddEventMaterial
  | AddEventMaterialSuccess
  | AddEventMaterialFailure
  | AddEventVisitsFailure
  | AddEventVisitsSuccess
  | AddEventVisits
  | GetEventVisits
  | GetEventVisitsSuccess
  | GetEventVisitsFailure
  | ClearEventVisits;
